@if (item.title) {
    <vn-pc-component-header-v2 [item]="item" />
}
<div class="pc-txt" [vnDynamicHtml]="item.text"></div>
